export const colorSet = [
  {
    title: "Light",
    colors: [
      "#3C50E0",
      "#E8EAFF",
      "#FFFFFF",
      "#000000",
      "#F5F7FD",
      "#4A4A4A",
      "#FAB100",
      "#FB546E",
    ],
  },
  {
    title: "Purple",
    colors: [
      "#C9FDE7",
      "#1C0C59",
      "#29186C",
      "#FFFFFF",
      "#412F86",
      "#FCFCFC",
      "#00D4E1",
      "#FB546E",
    ],
  },
  {
    title: "Deep Green",
    colors: [
      "#FFDA15",
      "#003C41",
      "#024348",
      "#D3FFFC",
      "#1C535C",
      "#B0D1D3",
      "#316087",
      "#2C929A",
    ],
  },
];

export const fonts = [
  {
    name: "Primary",
    value: "Poppins",
    provider: "google",
  },
];
